module.exports = __webpack_public_path__ + "static/assets/ad836ee2db1f368c51b355d90c5e8a8c.gif";